import createRouter from '@/router'
import { getAccessToken, getSubdomain } from '@/service/activeSession'
import { redirect } from '@attensi/redirect'
import { accessTokenToTransferKey } from '@attensi/session'

export const openRouteInTab = async (
  routeName: string,
  props: Record<string, any>
) => {
  const url = await getRouteURL(routeName, props)

  const accessToken = await getAccessToken()
  const transferKey = accessToken
    ? await accessTokenToTransferKey(accessToken)
    : undefined

  redirect.to({
    href: url,
    open_in_new_tab: true,
    transfer_key: transferKey,
  })
}

// Exported for the legacy journey item's link; goes with src/legacy.
export const getRouteURL = async (
  routeName: string,
  props: Record<string, any>
) => {
  const router = createRouter()
  const routerURL = router.resolve({ name: routeName, params: props }).href
  const subdomain = await getSubdomain()
  const url = `${window.location.origin}/${subdomain}${routerURL}`

  return url
}
